import { HttpStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { CodeEditor } from "components/UI/CodeEditor";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

export interface StepDetailHttpProps {
    extractedData: HttpStepSummary;
}

const parseBodyIfJson = (body: unknown): unknown => {
    if (typeof body === "string") {
        try {
            return JSON.parse(body);
        } catch {
            return body;
        }
    }
    return body;
};

export const StepDetailHttp: FC<StepDetailHttpProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.http");
    const { id, response, request } = extractedData;

    const responseDisplay = {
        ...(response.status != null ? { status: response.status } : {}),
        ...(response.method || response.uri ? { url: `${response.method ?? ""} ${response.uri ?? ""}`.trim() } : {}),
        ...(response.body != null ? { body: parseBodyIfJson(response.body) } : {}),
        ...(response.headers ? { headers: response.headers } : {}),
    };

    const requestDisplay = {
        ...(request.method || request.uri ? { url: `${request.method ?? ""} ${request.uri ?? ""}`.trim() } : {}),
        ...(request.query ? { query: request.query } : {}),
        ...(request.body != null ? { body: parseBodyIfJson(request.body) } : {}),
        ...(request.headers ? { headers: request.headers } : {}),
    };

    return (
        <>
            <DrawerCollapsible title={t("response")}>
                <CodeEditor
                    className="!max-h-80 rounded-lg border"
                    id={`step-detail-http-response-${id}`}
                    wrapEnabled
                    minLines={10}
                    maxLines={20}
                >
                    {JSON.stringify(responseDisplay, null, 2)}
                </CodeEditor>
            </DrawerCollapsible>
            <DrawerCollapsible title={t("request")}>
                <CodeEditor
                    className="!max-h-80 rounded-lg border"
                    id={`step-detail-http-request-${id}`}
                    wrapEnabled
                    minLines={10}
                    maxLines={20}
                >
                    {JSON.stringify(requestDisplay, null, 2)}
                </CodeEditor>
            </DrawerCollapsible>
        </>
    );
};
